import script from "./SideNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SideNavigation.vue?vue&type=style&index=0&id=eb9d1702&lang=scss"

const __exports__ = script;

export default __exports__